import { render, staticRenderFns } from "./SubproductForm.vue?vue&type=template&id=05b7816e&"
import script from "./SubproductForm.vue?vue&type=script&lang=js&"
export * from "./SubproductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports